/**
 * The refusals a media registration can give that are about the object key itself.
 *
 * One list, read on both sides of the wire. The backend throws each of these as the
 * `details.reason` of a coded app error; the upload queue reads the reason back to decide what
 * a Retry should do. That decision has exactly two answers, and the list is the line between
 * them: a reason named here says the bytes under the key cannot be registered by anyone — the
 * object is gone, the key was reclaimed or never ledgered, it belongs to another project, or
 * what R2 stored is not what was claimed — so the only Retry that can succeed starts from a
 * fresh key and a fresh upload. Every other coded refusal (storage not configured, access
 * denied, a name or class the file fails on) says nothing about the object, and the queue
 * keeps the key so the same upload can be registered once the cause is gone.
 */
export const MEDIA_KEY_REFUSAL_REASONS = {
    objectMissing: "media_object_missing",
    objectNotLedgered: "media_object_not_ledgered",
    objectReclaimed: "media_object_reclaimed",
    keyClaimedByAnotherProject: "media_key_claimed_by_another_project",
    keyProjectMismatch: "media_key_project_mismatch",
    contentTypeMismatch: "media_content_type_mismatch",
};
const MEDIA_KEY_REFUSAL_REASON_SET = new Set(Object.values(MEDIA_KEY_REFUSAL_REASONS));
/** Whether a coded refusal's `details.reason` names the object key rather than something else. */
export function isMediaKeyRefusalReason(reason) {
    return typeof reason === "string" && MEDIA_KEY_REFUSAL_REASON_SET.has(reason);
}
